import React, { useEffect, useState } from "react";
import {
  Col,
  Table,
  Row,
  Divider,
  Empty,
  Tooltip,
  Button,
  Typography,
} from "antd";
import constants from "../constants/constants.json";
import { useDispatch, useSelector } from "react-redux";
import {
  Loading3QuartersOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import Axios from "axios";
import moment from "moment";
import { setBilling, setDataPayment } from "../store/actions/user";
import Message from "../helper/Message";
import "./Billing.css";
import { useHistory } from "react-router-dom";

export default function Billing(props) {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const history = useHistory();
  const bill = useSelector((state) => state.userReducer.billing);

  const [data, setData] = useState(false);
  const payment = useSelector((state) => state.userReducer.dataPayment);
  const [checkout, setCheckout] = useState(false);
  const [chindex, setChindex] = useState(false);
  const [planMe, setPlanMe] = useState(false);

  const checkoutFn = async (uid) => {
    try {
      setCheckout(true);
      setChindex(uid);
      const token = localStorage.getItem("pnsToken");
      let response = await Axios.get(constants.url + "/plan/checkout/" + uid, {
        headers: {
          authorization: "Bearer " + token,
        },
      });

      if (response.data.status === 202) {
        window.location.href = response.data.result.checkout.url;
      } else {
        Message.error(response.data.result.message);
      }
      setCheckout(false);
      setChindex(false);
    } catch (err) {
      Message.error("Communication error");
      setCheckout(false);
      setChindex(false);
    }
  };

  const billinglist = async () => {
    try {
      setLoading(true);
      let token = localStorage.getItem("pnsToken");
      let responsePlan = await Axios.get(constants.url + "/plan/me", {
        headers: {
          authorization: "Bearer " + token,
        },
      });
      if (responsePlan.data.status === 202) {
        setPlanMe(responsePlan.data.result);
      } else {
        Message.error(responsePlan.data.result.message);
      }

      let response = await Axios.get(constants.url + "/billing/invoices", {
        headers: {
          authorization: "Bearer " + token,
        },
      });

      if (response.data.status === 202) {
        dispatch(setBilling(response.data.result));

        setLoading(false);
      } else {
        Message.error(response.data.result.message);
        setLoading(false);
      }
    } catch (err) {
      Message.error("Communication error");
      setLoading(false);
    }
  };

  const activePlan = async (uid) => {
    try {
      let token = localStorage.getItem("pnsToken");
      const res = await Axios.put(
        constants.url + "/plan/active/" + uid,
        false,
        {
          headers: {
            authorization: "Bearer " + token,
          },
        }
      );
      if (res.data.status === 202) {
        Message.success(res.data.result.message);
        billinglist();
      } else {
        Message.error(res.data.result.message);
      }
    } catch (error) {
      console.log(error);
      Message.error("Communication error");
    }
  };
  useEffect(() => {
    billinglist();
  }, []);

  const columnsparent = [
    {
      title: "Invoice Plan",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Invoice ID",
      dataIndex: "uid",
      key: "uid",
    },
    {
      title: "Usage Time",
      dataIndex: "usage",
      key: "usage",
      render: (usage) => {
        return <span>{usage} Secs</span>;
      },
    },
    {
      title: "Invoice Status",
      dataIndex: "status",
      key: "status",
      render: (status, record) => {
        return status === 1 ? (
          <Tooltip title="Successfull">
            <CheckCircleOutlined style={{ color: "green", fontSize: "20px" }} />
          </Tooltip>
        ) : status === 2 ? (
          <Tooltip title="Unsuccessfull">
            <CloseCircleOutlined style={{ color: "red", fontSize: "20px" }} />
          </Tooltip>
        ) : (
          <Tooltip title="Pending! No payment data.">
            <QuestionCircleOutlined
              style={{ color: "orange", fontSize: "20px" }}
            />
          </Tooltip>
        );
      },
    },
    { title: "Invoice Create Time", dataIndex: "time", key: "time" },
    {
      title: "Invoice Expire Time",
      dataIndex: "expireTime",
      key: "expireTime",
    },
    {
      title: "",
      dataIndex: "operation",
      key: "operation",
      render: (status, record) => {
        return !planMe ? null : record.uid ===
          planMe.invoice.uid ? null : record.expireUnixTime <
          moment().format("X") ? (
          <Typography.Text type="danger">expired</Typography.Text>
        ) : status === 1 ? (
          <Button
            type="primary"
            color="primary"
            onClick={() => activePlan(record.uid)}
          >
            active
          </Button>
        ) : null;
      },
    },
  ];
  const columnspayment = [
    {
      title: "Payment Refernce",
      dataIndex: "refrence",
      key: "refrence",
    },
    {
      title: "Payment Value",
      dataIndex: "value",
      key: "value",
    },
    {
      title: "Payment Gatewaye",
      dataIndex: "gateway",
      key: "gateway",
    },
    {
      title: "Payment Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        return status === 1 ? (
          <Tooltip title="Successfull">
            <CheckCircleOutlined style={{ color: "green", fontSize: "20px" }} />
          </Tooltip>
        ) : (
          <Tooltip title="Unsuccessfull">
            <CloseCircleOutlined style={{ color: "red", fontSize: "20px" }} />
          </Tooltip>
        );
      },
    },
    {
      title: "Payment Time",
      dataIndex: "payTime",
      key: "payTime",
    },
  ];
  const dataParent = [];
  const dataPayment = [];
  useEffect(() => {
    for (let index = 0; index < bill.length; index++) {
      dataParent.push({
        key: index,
        name: bill[index].invoice.name,
        value: bill[index].invoice.value,
        uid: bill[index].invoice.uid,
        usage: bill[index].invoice.usage,
        status: bill[index].invoice.status,
        time: moment(bill[index].invoice.time * 1000).format(
          "YYYY-MM-DD HH:mm"
        ),
        expireTime: moment(bill[index].invoice.expireTime * 1000).format(
          "YYYY-MM-DD HH:mm"
        ),
        expireUnixTime: bill[index].invoice.expireTime,
      });

      if (bill[index].payment.length !== 0) {
        for (let pindex = 0; pindex < bill[index].payment.length; pindex++) {
          dataPayment.push({
            key: index,
            refrence: bill[index].payment[pindex].refrence,
            value: bill[index].payment[pindex].value,
            status: bill[index].payment[pindex].status,
            gateway: bill[index].payment[pindex].gateway,
            createTime: moment(
              bill[index].payment[pindex].createTime * 1000
            ).format("YYYY-MM-DD HH:mm"),
            payTime: moment(bill[index].payment[pindex].payTime * 1000).format(
              "YYYY-MM-DD HH:mm"
            ),
          });
        }
      }
    }
    setData(dataParent);

    dispatch(setDataPayment(dataPayment));
  }, [bill]);

  const expandedRowRender = (row) => {
    let payArray = payment.filter((item, index) => {
      return item.key === row.key;
    });

    return payArray.length > 0 ? (
      <Table
        columns={columnspayment}
        dataSource={payArray}
        pagination={false}
      />
    ) : (
      <Empty
        style={{
          width: "100%",
        }}
        description="No payment for this invoice!"
      >
        {row.status !== 1 ? (
          <Button
            type="primary"
            onClick={() => checkoutFn(row.uid)}
            loading={
              chindex === row.uid ? (
                checkout ? (
                  <Loading3QuartersOutlined spin />
                ) : (
                  false
                )
              ) : (
                false
              )
            }
          >
            Checkout Invoice
          </Button>
        ) : (
          ""
        )}
      </Empty>
    );
  };

  return loading ? (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Loading3QuartersOutlined
        style={{ fontSize: "24px", color: "white" }}
        spin
      />
    </div>
  ) : (
    <Row>
      <Divider className="billing-divider">Invoices</Divider>
      <Col span={24}>
        {data.length > 0 ? (
          <Table
            rowClassName={(record, index) =>
              !planMe
                ? "table-row-dark"
                : record.uid === planMe.invoice.uid
                ? "table-row-light"
                : "table-row-dark"
            }
            className="components-table-demo-nested"
            columns={columnsparent}
            dataSource={data}
            expandable={{ expandedRowRender }}
            pagination={false}
          />
        ) : (
          <Empty
            style={{
              color: "white",
              width: "100%",
              marginTop: "50px",
            }}
            description="There is no billing data yet!"
          >
            <Button
              type="primary"
              onClick={() => history.push("/dashboard/plans")}
            >
              Buy a Plan
            </Button>
          </Empty>
        )}
      </Col>
    </Row>
  );
}
